import React from "react";
import SystemSettings from "../../components/system-settings/SystemSettings";
import { SYSTEM_CONFIGURATION_TABS } from "../../utils/AppEnumerations";

const ContentManagement = () => {
  return <SystemSettings menuId={SYSTEM_CONFIGURATION_TABS.ContentManagement} />;
};

export default ContentManagement;
